'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('./util'),
    get = _require.get,
    breaks = _require.breaks,
    merge = _require.merge,
    arr = _require.arr,
    dec = _require.dec,
    media = _require.media;

var REG = /^color|bg$/;

module.exports = function (props) {
  var keys = (0, _keys2.default)(props).filter(function (key) {
    return REG.test(key);
  });
  var bp = breaks(props);
  var palette = get(props, 'theme.colors', {});

  return keys.map(function (key) {
    var val = props[key];
    var prop = properties[key] || key;

    if (!Array.isArray(val)) {
      return (0, _defineProperty3.default)({}, prop, cx(palette)(val));
    }

    return val.map(cx(palette)).map(dec(prop)).map(media(bp)).reduce(merge, {});
  }).reduce(merge, {});
};

var cx = function cx(obj) {
  return function (n) {
    return get(obj, n + '', n);
  };
};

var properties = {
  bg: 'backgroundColor'
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/color.js
// module id = 84
// module chunks = 35783957827783 95816961762493 114276838955818 231178572073751